(function () {
	'use strict';

    angular.module("imApp").factory("consignmentPlansOrdersService", ['$ihttp', function ($ihttp) {
		let service = {
            listOrders: function (parms) {
                return $ihttp.post({
                    method: 1753,
                    parameters: parms || {}
                });
            },
            linkOrder: function (item) {
                return $ihttp.post({
                    method: 1754,
                    parameters: item
                });
            },
            createConsignment: function (item) {
                return $ihttp.post({
                    method: 1755,
                    parameters: item
                });
            },
            updateColumnResize: function (item) {
                return $ihttp.post({
                    method: 1457,
                    parameters: item
                });
            }
		};

		return service;
	}]);
})();
